module.exports = __webpack_public_path__ + "static/media/northville-hills-villas.73f11f47.pdf";